<!-- =========================================================================================
	File Name: MSMessageBox.vue
	Description: Component MsMessageBox - Component hiện thị thông báo
	----------------------------------------------------------------------------------------
	Author: nntam - 15/8/2019
========================================================================================== -->
<template>
  <div id="message-box">
    <!-- <div id="message-box" > -->
    <div class="con-ms-message-box" v-if="isShowMessage">
      <div class="message-center">
        <!-- @shortkey="escAction"
				 v-shortkey="{
					Close: ['esc'], //Đóng
				}" -->
        <div class="ms-message-bg"></div>
        <div class="ms-mesage-box">
          <div class="close-button" v-if="option.close" @click="isShowMessage = false"></div>

          <div class="ms-mesage-box-inactive" :style="[{ width: option.width, minWidth: '500px' }]">
            <div class="padding-20">
              <!-- 'align-items-center': (!showMessageDetail && option.title ==null) -->
              <div :class="{ 'msb-content': true }">
                <div class="icon-message" v-if="option.icon">
                  <div class="mi mi-52" :class="[option.icon]"></div>
                </div>
                <div class="message-content p-l-16 p-t-12">
                  <div class="title" v-if="option.title != null">
                    {{ option.title }}
                  </div>
                  <span id="idMessage" class="message" v-if="option.message != ''">{{
                    message
                  }}</span>
                  <div
                    class="mess-link"
                    v-if="
                      option.messageDetail && option.messageDetail.length > 0 && !showMessageDetail
                    "
                    @click="showMessageDetail = true"
                  >
                    <div class="mi mi-14 mi-chevron-down--primary-small"></div>
                    <div>Mở rộng</div>
                  </div>
                  <div
                    v-if="
                      option.messageDetail && option.messageDetail.length > 0 && showMessageDetail
                    "
                  >
                    <ul class="detail-container">
                      <li
                        v-for="(detailItem, detailIndex) in option.messageDetail"
                        v-key="detailIndex"
                      >
                        {{ detailItem }}
                      </li>
                    </ul>
                    <div
                      class="mess-link"
                      v-if="
                        option.messageDetail !== '' &&
                        option.messageDetail != null &&
                        showMessageDetail
                      "
                      @click="showMessageDetail = false"
                    >
                      <div class="mi mi-14 mi-chevron-up--primary-small"></div>
                      <div>Thu gọn</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mess-line"></div>
              <div class="mess-footer" v-on:keydown="footerKeydown" v-if="showButton">
                <!-- nntam - 16/04/2020 thêm computed để bog v-if lồng v-for -->
                <div
                  :class="[button.target, 'btn-size']"
                  v-for="button in listBtn"
                  :key="button.key"
                >
                  <ms-button
                    @keydown="escAction"
                    class="w-100"
                    :type="button.typeButton"
                    :ref="button.focus ? 'btnFocus' : 'btnOther'"
                    @click="btnClick(button.key)"
                    :text="button.text"
                  ></ms-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonFunction from "@/commons/commonFunction";
export default {
  name: "MsMessageBox",
  props: {
    // chiều rộng của messagebox
    width: {
      type: String,
      default: "444px",
    },
    // option cấu hình messageBox
    option: {
      type: Object,
      default: null,
    },
  },
  computed: {
    listBtn() {
      return this.option.btnConfig.filter((x) => x.hasBtn == true);
    },
  },
  data() {
    let showButton = false;
    for (let i = 0; i < this.option.btnConfig.length; i++) {
      if (this.option.btnConfig[i].hasBtn) {
        showButton = true;
        break;
      }
    }

    return {
      isShowMessage: true,
      showMessageDetail: false,
      message: "",
      showButton: showButton,
    };
  },
  methods: {
    /**
     * Bắt sự kiện click vào button
     */
    btnClick(key) {
      this.isShowMessage = false;
      this.$emit("btnClick", this, key);
    },
    escapeContent(htmlContent) {
      //Thay đổi toàn bộ kí tự đặc biệt `<`, `>` sang ký hiệu tương ứng để không bị ảnh hưởng việc hiển thị html
      return htmlContent.replace(/>/g, "&gt;").replace(/</g, "&lt;");
    },
    escAction(e) {
      const shortkey = e.target.getAttribute("shortkey");
      if (shortkey && shortkey.split("|").indexOf(e.srcKey) > -1) {
        e.preventDefault();
        this.isShowMessage = false;
      }
    },
    footerKeydown(e) {
      const me = this;
      commonFunction.processUnfocusLastControl(e, function () {
        commonFunction.focusFirstControl(me.$el);
      });
    },
    linkActive_OnClick() {
      this.$emit("linkActive");
      if (this.option.closeMessageAfterLink) {
        this.isShowMessage = false;
      }
    },
    linkPopup_OnClick() {
      this.$emit("linkPopup");
      this.isShowMessage = false;
    },
  },
  mounted() {
    //Focus
    const btnFocusRefs = this.$refs["btnFocus"];
    const btnFocusEl = Array.isArray(btnFocusRefs)
      ? (btnFocusRefs[0]?.$el ?? btnFocusRefs[0])
      : (btnFocusRefs?.$el ?? btnFocusRefs);
    if (btnFocusEl && typeof btnFocusEl.focus === "function") {
      btnFocusEl.focus();
    } else {
      let primaryBtn = this.$el.querySelector(".ms-button-primary");
      if (primaryBtn) {
        primaryBtn.focus();
      } else {
        commonFunction.focusFirstControl(this.$el);
      }
    }

    // hiện thị text ra message box
    var tt = document.getElementById("idMessage");
    if (this.option.message != "" && tt != null) {
      // nếu truyền thml thì vẫn để thế còn truyền text thì chuyển lại thành ký từ đặc biệt để nó không bị biến thành html khi hiển thị
      if (
        /<(?=.*? .*?\/ ?>|br|hr|input|!--|wbr)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i.test(
          this.option.message,
        )
      ) {
        tt.innerHTML = this.option.message;
      } else {
        this.message = this.option.message;
      }
    }

    let linkActive = this.$el.querySelector(".link-active"),
      linkPopup = this.$el.querySelector(".link-open-popup");

    if (linkActive !== null) {
      linkActive.addEventListener("click", this.linkActive_OnClick);
    }
    if (linkPopup !== null) {
      linkPopup.addEventListener("click", this.linkPopup_OnClick);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/msMessageBox.scss";
</style>
